import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'button'];

  initialize() {
    this.checkEnableability = this.checkEnableability.bind(this);
  }

  connect() {
    this.checkEnableability();
  }

  checkEnableability() {
    if (this.inputTarget.value === '') {
      this.buttonTarget.disabled = true;
    } else {
      this.buttonTarget.disabled = false;
    }
  }
}
